import gql from 'graphql-tag';
import { ATTACHMENT_FIELDS } from './projectDocumentsFragment';

/**
 * Data of the block project-acceptance-report-build ("Abnahmeprotokoll: Bericht generieren"): the
 * generated PDF, the ZIP of the acceptance photos and their build states. Read through
 * `Project.blocks.acceptanceReportBuild`, which checks the block's read permission.
 */
export const PROJECT_ACCEPTANCE_REPORT_BUILD_FIELDS = gql`
  fragment projectAcceptanceReportBuildFields on ProjectAcceptanceReportBuildBlock {
    id
    number
    reportAttachments {
      ${ATTACHMENT_FIELDS}
    }
    reportAttachmentsBuildState
    acceptanceReportImageAttachmentsZip {
      ${ATTACHMENT_FIELDS}
    }
    acceptanceReportImageAttachmentsZipBuildState
  }
`;
